export const RouteFilterReducer = (state, action) => {
    switch (action.type) {
        case "SELECT_ROUTE_TYPE":
            return {...state, selectedRouteType: [action.routeType]}
        default:
            return state
    }
}


// WEBPACK FOOTER //
// ./src/components/routeView/reducers/RouteFilterReducer.js